var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-200.000000, -629.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.000000, 630.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "36.2166667 8 41 8 41 39 0 39 0 8 4.78333333 8"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "31.3088192 4.2571899 36 3 36 34.8461538 20.5 39 5 34.8461538 5 3 9.75156933 4.27337342"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10 0 20.5 6.78571429 31 0 31 31.2142857 20.5 38 10 31.2142857"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.5,
    y1: 7,
    x2: 20.5,
    y2: 39
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourse);
export default __webpack_public_path__ + "static/media/icon-course.3b8330d74598585e73f777cf403bc44f.svg";
export { ForwardRef as ReactComponent };